import { render, staticRenderFns } from "./case-line.vue?vue&type=template&id=5f2ed873&scoped=true&"
import script from "./case-line.vue?vue&type=script&lang=js&"
export * from "./case-line.vue?vue&type=script&lang=js&"
import style0 from "./case-line.vue?vue&type=style&index=0&id=5f2ed873&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2ed873",
  null
  
)

export default component.exports